import React, { useState } from 'react';
import '../../css/FAQs.css'; // Import the CSS file

const FAQCOGATs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is the Cognitive Abilities Test (CoGAT)?",
      answer: "The Cognitive Abilities Test (CoGAT) is a standardized assessment designed to measure a student's reasoning and problem-solving abilities across three key areas: verbal reasoning, quantitative reasoning, and nonverbal reasoning. The test helps identify students' cognitive strengths and is commonly used by school districts for gifted and talented program placements, academic grouping, and understanding learning potential."
    },
    {
      question: "Why is the CoGAT test important for elementary school students?",
      answer: "The CoGAT test is important because it helps identify students who may benefit from advanced or gifted programs. It assesses cognitive abilities rather than just academic achievement, providing insights into how students think and solve problems. Many school districts use CoGAT scores to make placement decisions and to understand each student's learning style and potential."
    },
    {
      question: "How can my child prepare for the CoGAT test?",
      answer: "The best way to prepare for CoGAT is through regular practice with sample questions from all three batteries (verbal, quantitative, and nonverbal). Familiarize your child with the question formats, practice pattern recognition, and work on reasoning skills. Our free practice platform offers thousands of CoGAT sample questions with detailed explanations to help students build confidence and improve their performance."
    },
    {
      question: "What grade levels take the CoGAT test?",
      answer: "The CoGAT test is typically administered to students in grades K-12, with age-appropriate question sets for each grade level. Many school districts administer it at specific grade levels (often grades 2, 4, or 6) for gifted program identification. The test format and difficulty are adjusted based on the student's grade level."
    },
    {
      question: "What types of questions are on the CoGAT test?",
      answer: "The CoGAT test includes multiple-choice questions across three batteries: Verbal (picture analogies, sentence completion, classification), Quantitative (number analogies, number puzzles, number series), and Nonverbal (figure matrices, paper folding, figure classification). All questions are designed to assess reasoning abilities rather than memorized facts, making practice with similar question types very helpful."
    },
    {
      question: "How long does the CoGAT test take?",
      answer: "The CoGAT test typically takes 60-75 minutes to complete, though it may be administered in multiple sessions depending on the school's schedule. Each battery (verbal, quantitative, nonverbal) usually takes about 20-25 minutes. The exact timing can vary by grade level and school district."
    },
    {
      question: "How is the CoGAT test scored?",
      answer: "CoGAT scores are reported using several metrics including raw scores, standard age scores (SAS), percentile ranks, and stanines. Scores are compared to national norms for the student's age group. Higher scores indicate stronger reasoning abilities in each area. Many gifted programs look for students scoring in the 90th percentile or higher."
    },
    {
      question: "Can students practice for the CoGAT test online?",
      answer: "Yes! Students can practice for the CoGAT test using online practice platforms like SmartKids Prep, which offers free access to thousands of CoGAT sample questions. Online practice helps students become familiar with the question formats, timing, and types of reasoning required. Practice tests are available for all three batteries with detailed explanations for each answer."
    }
  ];


  return (
    <section className="cogat-faq-section" aria-label="CoGAT Frequently Asked Questions">
      <div className="cogat-faq-wrapper">
        <h2 className="cogat-faq-title">
          Frequently Asked Questions About CoGAT
        </h2>
        <p className="cogat-faq-intro">
          Find answers to common questions about the Cognitive Abilities Test (CoGAT), test preparation, scoring, and more.
        </p>
        <div className="faq-container">

        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => toggleQuestion(index)}
              style={{ cursor: 'pointer' }}
            >
              {faq.question}
              <span className={`faq-toggle-icon ${openIndex === index ? 'open' : ''}`}>
                {openIndex === index ? '-' : '+'}
              </span>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
        </div>
      </div>
    </section>
  );
};

export default FAQCOGATs;